import styled from 'styled-components'

import {
  backgroundTypes,
  borderTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
} from '../types'
import { background, border, boxModel, css, display } from '../util'

/**
 * @namespace Nav
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Nav = styled.nav`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  ${display};
`

/**
 * @name defaultProps
 * @memberof Nav
 * @desc Primitive's default properties
 */
Nav.defaultProps = {
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Nav
 * @desc Primitive's prop type definitions
 */
Nav.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
}

/** @component */
export default Nav
